import React, { PureComponent } from 'react'
import t from 'prop-types'

import Error from './pages/Error'
// import Maintenance from './pages/Maintenance'

class ErrorPrevent extends PureComponent {
  state = { hasError: false }

  static getDerivedStateFromError () {
    return { hasError: true }
  }

  render () {
    if (this.state.hasError) {
      // return <Maintenance />
      return <Error />
    }

    return this.props.children
  }
}

ErrorPrevent.propTypes = {
  children: t.object.isRequired
}

export default ErrorPrevent
